const BASE_URL = process.env.REACT_APP_API_SITE_URL;

export const API_ENDPOINTS = {
    SITE_METADATA: `${BASE_URL}/wp-json/api/v2/content/site-metadata`,
    BANNER_ENDPOINT: `${BASE_URL}/wp-json/api/v2/profile/sliders`,
    PAGE_ENDPOINT: `${BASE_URL}/wp-json/wp/v2/pages/`,
    EXPERTISE_ENDPOINT: `${BASE_URL}/wp-json/api/v2/profile/expertises`,
    EDUCATION_ENDPOINT: `${BASE_URL}/wp-json/api/v2/profile/educations`,
    EXPERIENCES_ENDPOINT: `${BASE_URL}/wp-json/api/v2/profile/experiences`,
    THREEES_ENDPOINT: `${BASE_URL}/wp-json/api/v2/profile/3es`,
    SKILL_ENDPOINT: `${BASE_URL}/wp-json/api/v2/profile/skills?per_page=20`,
    POSTS_ENDPOINT: `${BASE_URL}/wp-json/api/v2/content/posts`,
    CATEGORY_ENDPOINT: `${BASE_URL}/wp-json/api/v2/content/categories`,
    POPULAR_GET_ENDPOINT: `${BASE_URL}/wp-json/api/v2/content/popular-posts`,
    POPULAR_POST_ENDPOINT: `${BASE_URL}/wp-json/wordpress-popular-posts/v2/views`,
    TAG_CLOUD_ENDPOINT: `${BASE_URL}/wp-json/api/v2/content/tag-cloud`,
    RELARED_POST_ENDPOINT: `${BASE_URL}/wp-json/api/v2/content/related-posts`,
    COMMNT_ENDPOINT: `${BASE_URL}/wp-json/api/v2/content/posts/comments`,
    COMMENT_REACTION_ENDPOINT: `${BASE_URL}/wp-json/api/v2/content/posts/comments/comment-reaction`,
    CONTACT_FORM_ENDPOINT: `${BASE_URL}/wp-json/contact-form-7/v1/contact-forms/5/feedback`,
    CERTIFICATIONS_ENDPOINT: `${BASE_URL}/wp-json/api/v2/profile/certifications`
};